import Backbone from 'backbone';
import Model from 'app/cms/carpricechecker/models/BrandModel';


class Collection extends Backbone.Collection {
	get model() {
		return Model;
	}
}

export default Collection;
